<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="successMessage.showSuccessMessage">
                    {{successMessage.message}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage.showErrorMessage">
                    {{errorMessage.message}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="validateFuelDispensing" v-if="!successMessage.showSuccessMessage && !errorMessage.showErrorMessage">
                    <div class="form-group">
                        <label for="orderNumberInput">
                            Order Number
                        </label>
                        <div class="text-danger" v-if="fuelDispensement.orderNumber.hasError">
                            {{ fuelDispensement.orderNumber.errorMessage}}
                        </div>
                        <input type="text" placeholder="Order Number" class="form-control" id="orderNumberInput" v-model="fuelDispensement.orderNumber.value" disabled>
                    </div>
                    <div class="form-group">
                        <label for="vehicleRegistrationInput">
                            Vehicle Registration
                        </label>
                        <div class="text-danger" v-if="fuelDispensement.vehicleRegistration.hasError">
                            {{ fuelDispensement.vehicleRegistration.errorMessage}}
                        </div>
                        <input type="text" class="form-control" id="vehicleRegistrationInput" v-model="fuelDispensement.vehicleRegistration.value" disabled>
                    </div>
                    <div class="form-group">
                        <label for="odometerReadingInput">
                            Odometer Reading
                        </label>
                        <div class="text-danger" v-if="fuelDispensement.odometerReading.hasError">
                            {{ fuelDispensement.odometerReading.errorMessage}}
                        </div>
                        <input type="text" class="form-control" id="odometerReadingInput" v-model="fuelDispensement.odometerReading.value">
                    </div>
                    <div class="text-danger">
                        {{orderItemsDispensedErrorMessage}}
                    </div>
                    <div class="table-responsive pt-4">
                        <table class="table table-hover mb-0">
                            <thead>
                            <tr>
                                <th>Product</th>
                                <th style="width:20%">Pump</th>
                                <th>Pump Opening Meter</th>
                                <th>Pump Closing Meter</th>
                                <th>Quantity Ordered</th>
                                <th>Quantity Dispensed</th>
                                <th>Order Value</th>
                                <th>Value Dispensed</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(orderItem, index) in orderItemsDispensed" :key="index">
                                <td>{{orderItem.product}}</td>
                                <td>
                                    <div class="text-danger">
                                        {{orderItem.pumpId.errorMessage}}
                                    </div>
                                    <select class="form-control" v-model="orderItem.pumpId.value">
                                        <option v-for="pump in pumps" :key="pump.depotPumpId" :value="pump.depotPumpId">{{pump.pumpNumberTankRegistration}}</option>
                                    </select>
                                </td>
                                <td>
                                    <div class="text-danger">
                                        {{orderItem.pumpReadingStart.errorMessage}}
                                    </div>
                                    <input type="number" class="form-control" v-model="orderItem.pumpReadingStart.value" @input="onPumpReadingStartInput(orderItem)">
                                </td>
                                <td>
                                    <div class="text-danger">
                                        {{orderItem.pumpReadingEnd.errorMessage}}
                                    </div>
                                    <input type="number" class="form-control" v-model="orderItem.pumpReadingEnd.value" @input="onPumpReadingEndInput(orderItem)">
                                </td>
                                <td>
                                    {{orderItem.quantity}}
                                </td>
                                <td>
                                    <div class="text-danger">
                                        {{orderItem.quantityDispensed.errorMessage}}
                                    </div>
                                    <input type="number" class="form-control" v-model="orderItem.quantityDispensed.value" disabled>
                                </td>
                                <td>
                                    {{orderItem.totalAmountAsString}}
                                </td>
                                <td>
                                    {{orderItem.totalAmountDispensedAsString}}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6">
                                    <b>Total:</b>
                                </td>
                                <td>
                                    {{collectionOrder.totalAmountAsString}}
                                </td>
                                <td>
                                    {{collectionOrder.totalAmountDispensedAsString}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <button class="btn btn-primary mr-2" :disabled="loading">Done</button>
                </form>
            </div>
        </div>
    </div>

    <error-modal :modalHeading="errorModal.modalHeading"
                 :elementId="errorModal.elementId"
                 :modalMessage="errorModal.modalMessage"
                 :showModal="errorModal.showModal"
                 @okClicked="errorModelOkClicked"></error-modal>

    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="successModal.elementId"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="successModelOkClicked"></success-modal>
    
</div>
